import { axios } from '@/utils/request';
import qs from 'qs';

const metaData = {
  query_metadata_list: '/api/1/metadata/config/query_metadata_list.json'
};

/**
 *  根据对象ID和key获取元数据
 * @param objectId 对象ID
 * @param key 对象key
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const QueryMetadataList = (objectId, key) =>
  axios.get(metaData.query_metadata_list, {
    params: { objectId: objectId, key: key, pageSize: 6 }
  });
